//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageListItem from './grid/image-list/ImageListItem'
import ListItem from './grid/ListItem'
import Card from './grid/cards/Card'
import { mapGetters } from "vuex";
export default {
	name: "AppGrid",
	components: {
		appImageListItem: ImageListItem,
		appListItem: ListItem,
		appCard: Card
	},
	props: ['layout'],
  computed: {
		...mapGetters(["items"])
  }
};
